// The three truthful non-live screens (D9, DISCREPANCIES-V2 §2). Split out of
// App.tsx so the copy — one sentence of which is doctrine — is test-pinned by
// a component test instead of living unasserted inside the phase switch.

import type { NotLiveStatus } from './linkPhase';

/** P4's exact sentence, unchanged (DISCREPANCIES-V2 §2 rule 1). */
export const LINK_EXPIRED_COPY = 'This session link has expired and is no longer valid.';

export function NotLive({ status }: { status: NotLiveStatus }) {
  switch (status) {
    // No "check again" on the terminal states: expiry is a fixed instant that
    // never un-passes, and an ended session needs a NEW link, not a retry.
    case 'expired':
      return (
        <div className="screen">
          <h1>{LINK_EXPIRED_COPY}</h1>
          <p>Please ask your physiotherapist for a new link.</p>
        </div>
      );

    case 'ended':
      return (
        <div className="screen">
          <h1>This session has ended</h1>
          <p>Your physiotherapist can send you a new link when it is time for your next session.</p>
        </div>
      );

    case 'pending':
      return (
        <div className="screen">
          <h1>Not started yet</h1>
          <p>
            Your physiotherapist has not opened the session yet. Keep this page open — check back in
            a moment.
          </p>
          <button onClick={() => window.location.reload()}>Check again</button>
        </div>
      );
  }
}
